import FollowUpActions from "../components/FollowUpActions";
import {
  EventCard, ProgramCard, PlayerCard, CoachCard, ScoutCard, AgentCard, ChallengeCard, CourseCard, ComparisonCard, CampaignCard,
  TrainingPlanCard, TrainingSketchCard, NutritionPlanCard, TeamPlanCard, SummaryCard,
  ErrorCard, PaymentRequiredCard, JobCard, JobCreatedCard, EventCreatedCard, ServiceCreatedCard, TalentSessionCard, TalentReportCard,
} from "../components/ResultCards";
import type { Cta } from "../types/ginoQuery";

export const reconstructCard = (
  cardType: string,
  cardData: any,
  key: string,
  onCta?: (cta: Cta) => void,
  onBuyCredits?: () => void,
): React.ReactNode | null => {
  switch (cardType) {
    // Event/Player cards render their per-item CTA rows only when onCta is wired —
    // pass it so restored history cards keep their inline buttons.
    case "event": return <EventCard key={key} output={cardData} onCta={onCta} />;
    case "program": return <ProgramCard key={key} output={cardData} />;
    case "player": return <PlayerCard key={key} output={cardData} onCta={onCta} />;
    case "coach": return <CoachCard key={key} output={cardData} onCta={onCta} />;
    case "scout": return <ScoutCard key={key} output={cardData} onCta={onCta} />;
    case "agent": return <AgentCard key={key} output={cardData} onCta={onCta} />;
    case "challenge": return <ChallengeCard key={key} output={cardData} onCta={onCta} />;
    case "course": return <CourseCard key={key} output={cardData} onCta={onCta} />;
    case "comparison": return <ComparisonCard key={key} output={cardData} />;
    case "campaign": return <CampaignCard key={key} output={cardData} />;
    case "training_plan": return <TrainingPlanCard key={key} output={cardData} />;
    case "training_sketch": return <TrainingSketchCard key={key} output={cardData} />;
    case "nutrition_plan": return <NutritionPlanCard key={key} output={cardData} />;
    case "team_plan": return <TeamPlanCard key={key} output={cardData} />;
    case "summary": return <SummaryCard key={key} output={cardData} />;
    case "error": return <ErrorCard key={key} message={cardData?.message || "Error"} />;
    case "payment_required": return <PaymentRequiredCard key={key} data={cardData} onBuyCredits={onBuyCredits} />;
    case "hire_job": return <JobCard key={key} output={cardData} />;
    case "hire_job_created": return <JobCreatedCard key={key} output={cardData} />;
    case "event_created": return <EventCreatedCard key={key} output={cardData} />;
    case "service_created": return <ServiceCreatedCard key={key} output={cardData} />;
    case "talent_report": return <TalentReportCard key={key} report={cardData} />;
    case "follow_up_actions":
      return (
        <FollowUpActions
          key={key}
          ctas={cardData?.ctas || []}
          rtl={cardData?.rtl}
          onCta={cta => onCta?.(cta)}
        />
      );
    default: return null;
  }
};
